import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors

const getTextToSpeechState = (state: RootState) => state.textToSpeech;

export const getAudioContentSelector = createSelector(
  [getTextToSpeechState],
  (textToSpeech) => textToSpeech?.audioContent,
);
